// Redistribución de porcentajes del árbol de prorrateo (TreeClassificator).
//
// Los tres niveles del árbol (cuenta / atributo / subatributo) repartían el
// 100% con el MISMO algoritmo copiado tres veces; esto lo unifica.
//
// Trabaja en base 1000 (= 100.0%) sobre un array —posiblemente disperso, porque
// se indexa por `.order`— de items `{ fakeId, percentage }`:
//   1. escala cada `percentage` a base 1000 (Math.round(p * 10));
//   2. toma el primer item no vacío como "base" y lo fija en 1000;
//   3. al recorrer el resto: el item cuyo `fakeId === usedFakeId` se marca como
//      seleccionado; los demás se restan de la base (así la suma cierra exacta);
//   4. al seleccionado se le asigna, si `calculatePercentage`, la mitad de lo
//      que le queda a la base (split al editar la clasificación); si no, su
//      propio porcentaje escalado (el usuario tipeó un valor) y la base absorbe
//      la diferencia;
//   5. clamp: la base nunca baja de 1 (si se pasa, el faltante sale del
//      seleccionado).
//
// Muta los items in place (quedan en base 1000) y devuelve el mismo array. El
// caller divide por 10 al volcar el resultado al árbol real.
export function redistributePercents(orderedItems, usedFakeId, calculatePercentage) {
    orderedItems.forEach((item) => {
        if (item) item.percentage = Math.round(item.percentage * 10);
    });

    let iFirst = 0;
    while (iFirst < orderedItems.length && !orderedItems[iFirst]) iFirst++;
    if (iFirst >= orderedItems.length) return orderedItems;

    const base = orderedItems[iFirst];
    base.percentage = 1000;

    let iSelected = -1;
    for (let i = iFirst + 1; i < orderedItems.length; i++) {
        if (!orderedItems[i]) continue;
        if (orderedItems[i].fakeId == usedFakeId) {
            iSelected = i;
        } else {
            base.percentage -= orderedItems[i].percentage;
        }
    }
    if (iSelected < 0) return orderedItems;

    let actualPercent = orderedItems[iSelected].percentage;
    orderedItems[iSelected].percentage = 0;
    if (calculatePercentage) {
        actualPercent = parseInt(base.percentage / 2, 10);
    }
    base.percentage -= actualPercent;
    if (base.percentage < 0) {
        actualPercent += base.percentage - 1;
        base.percentage = 1;
    }
    orderedItems[iSelected].percentage = actualPercent;
    return orderedItems;
}
